"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buildCardData() {
    return {
        cardholderName: '',
        cardType: '',
        last4: '',
    };
}
exports.buildCardData = buildCardData;
function buildTokenizedCreditCardData() {
    return {
        encryptedSecurityCode: '',
        encryptedExpiryMonth: '',
        encryptedExpiryYear: '',
        encryptedCardNumber: '',
    };
}
exports.buildTokenizedCreditCardData = buildTokenizedCreditCardData;
function buildBillingCardAddress() {
    return {
        countryCode: '',
        postalCode: '',
    };
}
exports.buildBillingCardAddress = buildBillingCardAddress;
//# sourceMappingURL=card_data.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/card_data.js
// module id = hX2Q
// module chunks = 20 21 22